import Feature from '@rsa-digital/evo-shared-components/components/Feature/Feature';
import mediaQuery from '@rsa-digital/evo-shared-components/helpers/mediaQuery';
import spacing from '@rsa-digital/evo-shared-components/helpers/spacing';
import styled from 'styled-components';

export const StyledFeature = styled(Feature)`
  && {
    margin-top: ${spacing(3)};
    margin-bottom: ${spacing(3)};

    ${mediaQuery.tabletLandscape`
      margin-top: ${spacing(4)};
      margin-bottom: ${spacing(4)};
    `}
  }
`;
